// extracted by mini-css-extract-plugin
export default {"gttl-banner":"gttl-banner-7f4e","initial-rent":"initial-rent-477a","confetti_m_img":"confetti_m_img-3ce0","confetti_img":"confetti_img-618e","gttl-icon":"gttl-icon-7b1d"};